import { formateDate } from '@/utils/date';
import DocumentFormattation from '@/domain/formattation/DocumentFormattation';

export default class Orders {
    constructor(
        public situation: string,
        public companyName: string,
        public companyId: number,
        public document: string,
        public inclusionDate: string,
        public innId: string,
        public customerInnId: string,
        public number: string,
        public salesChannel: string,
        public status: string,
        public sector: number,
        public district: number,
        public bankCode: string,
        public cutoffTime: string,
    ) {}

    public static make(data: any): Orders {
        return new Orders(
            'Bloqueados no Crédito',
            data.companyName,
            data.companyId,
            DocumentFormattation.chooseTheValidDocumentFormattation(data.document),
            formateDate(data.inclusionDate),
            data.innId,
            data.customerInnId,
            data.number,
            data.salesChannel,
            data.status,
            data.sector ?? '',
            data.district ?? '',
            data.bankCode,
            data.cutoffTime,
        );
    }
}
